import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
// @mui
import { Container, Tab, Tabs, Box, Typography } from "@mui/material";
// routes
import { PATH_AUTH } from "../../routes/paths";
// auth
import { useAuthContext } from "../../auth/useAuthContext";
// components
import { useSettingsContext } from "../../components/settings";
import Iconify from "../../components/iconify/Iconify";
import { useSnackbar } from "../../components/snackbar";
// sections
import UserChangePassword from "../../sections/dashboard/user/UserChangePassword";
import UserEditForm from "../../sections/dashboard/user/UserEditForm";

// ----------------------------------------------------------------------

export default function Profile() {
  const { themeStretch } = useSettingsContext();
  const [currentTab, setCurrentTab] = useState("general");
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();


  const handleLogout = async () => {
    try {
      logout();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  const TABS = [
    {
      value: "general",
      label: "General",
      icon: <Iconify icon="ic:round-account-box" />,
      component: (
        <UserEditForm logout={handleLogout} isEdit currentUser={user} />
      ),
    },
    {
      value: "change-password",
      label: "Change Password",
      icon: <Iconify icon="ic:round-vpn-key" />,
      component: <UserChangePassword />,
    },
  ];
  return (
    <>
      <Helmet>
        <title> Profile : Carnation admin panel</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <Typography sx={{ mb: 4 }} variant="h4" gutterBottom>
          {`Welcome, ${user?.name}`}
        </Typography>
        <Tabs
          value={currentTab}
          onChange={(event, newValue) => setCurrentTab(newValue)}
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              icon={tab.icon}
              value={tab.value}
            />
          ))}
        </Tabs>

        {TABS.map(
          (tab) =>
            tab.value === currentTab && (
              <Box key={tab.value} sx={{ mt: 5 }}>
                {tab.component}
              </Box>
            )
        )}
      </Container>
    </>
  );
}
